function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef, useEffect, useState } from "react";
import { Button, Keyboard, Platform, TextInput as RNTextInput } from "react-native";
import { useAccessibilityContext } from "../AccessibilityContext";
import { AccessibleInput } from "../../hooks/useAccessibleInput";
import { useI18n } from "../../lib/i18n";
import { addBreadcrumb } from "../../lib/log";
import { useTheme } from "../../styles";
/**
 * @nosync
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-43}
 */ export var getStyles = function(theme) {
    var _theme_textInput_outlined_marginVertical, _theme_textInput_outlined_paddingVertical;
    return {
        outlined: {
            backgroundColor: 'white',
            borderColor: '#C6C6D4',
            borderRadius: 30,
            borderWidth: 1,
            color: theme.color.gray100,
            fontFamily: 'OpenSansRegular',
            fontSize: theme.textInput.outlined.fontSize,
            lineHeight: theme.textInput.outlined.lineHeight,
            marginVertical: (_theme_textInput_outlined_marginVertical = theme.textInput.outlined.marginVertical) !== null && _theme_textInput_outlined_marginVertical !== void 0 ? _theme_textInput_outlined_marginVertical : 4,
            padding: 16,
            paddingVertical: (_theme_textInput_outlined_paddingVertical = theme.textInput.outlined.paddingVertical) !== null && _theme_textInput_outlined_paddingVertical !== void 0 ? _theme_textInput_outlined_paddingVertical : 16
        },
        flat: {
            borderBottomWidth: 1,
            borderColor: '#C6C6D4',
            color: theme.color.gray100,
            fontFamily: 'OpenSansRegular',
            padding: 10,
            paddingVertical: 16
        },
        focused: {
            borderColor: '#4A8EF4',
            elevation: 4,
            shadowColor: '#2060C2',
            shadowOffset: {
                width: 0,
                height: 0
            },
            shadowOpacity: 0.3,
            shadowRadius: 3
        }
    };
};
/**
 * Allows editing of a string value by the user.
 *
 * {@adf 💾̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̅̃̀̀̆̉̀̀̆̎̀̀̆̇̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̆̌̀̀̆́̀̀̇̉̀̀̆̏̀̀̇̅̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆́̀̀̆̌̀̀̆̉̀̀̆̇̀̀̆̎̀̀̂̍̀̀̇̃̀̀̇̄̀̀̆́̀̀̇̂̀̀̇̄̀̀̂̂̀̀̇̍̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̎̀̀̇̄̀̀̆̅̀̀̆̎̀̀̇̄̀̀̂̂̀̀̃̊̀̀̅̋̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̆̀̀̆̉̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̉̀̀̆̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̃̂̀̀̃̄̀̀̃̅̀̀̃̀̀̀̃̇̀̀̃̂̀̀̆̅̀̀̆́̀̀̂̍̀̀̆̃̀̀̆́̀̀̆̆̀̀̃̃̀̀̂̍̀̀̃̄̀̀̆́̀̀̃̈̀̀̃̀̀̀̂̍̀̀̆̂̀̀̃̉̀̀̃̇̀̀̆̃̀̀̂̍̀̀̃̄̀̀̆̂̀̀̃̅̀̀̆̄̀̀̃̃̀̀̆̆̀̀̃̉̀̀̃̂̀̀̃̇̀̀̆̃̀̀̆̅̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̆̌̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̉̀̀̆̍̀̀̆́̀̀̆̇̀̀̆̅̀̀̂̍̀̀̃̂̀̀̃̀̀̀̃̂̀̀̃̅̀̀̃̀̀̀̃̃̀̀̃̃̀̀̃́̀̀̂̍̀̀̃́̀̀̃̈̀̀̃̅̀̀̃̅̀̀̃̅̀̀̃̃̀̀̂̎̀̀̇̀̀̀̆̎̀̀̆̇̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̌̀̀̆̌̀̀̆̅̀̀̆̃̀̀̇̄̀̀̆̉̀̀̆̏̀̀̆̎̀̀̂̂̀̀̃̊̀̀̂̂̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̈̀̀̆̅̀̀̆̉̀̀̆̇̀̀̆̈̀̀̇̄̀̀̂̂̀̀̃̊̀̀̃̂̀̀̃̀̀̀̃̄̀̀̂̌̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃̇̀̀̃̂̀̀̃̉̀̀̇̍̀̀̇̍̀̀̅̍̀̀̇̍}
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-43}
 */ export var TextInput = /*#__PURE__*/ forwardRef(function TextInput(_param, ref) {
    var ariaLabel = _param['aria-label'], component = _param.component, hint = _param.hint, inputStyle = _param.inputStyle, error = _param.error, disabled = _param.disabled, label = _param.label, labelColor = _param.labelColor, labelWeight = _param.labelWeight, labelHorizontal = _param.labelHorizontal, variant = _param.variant, value = _param.value, style = _param.style, onChangeValue = _param.onChangeValue, onFocus = _param.onFocus, onBlur = _param.onBlur, onLabelLayout = _param.onLabelLayout, onSubmitEditing = _param.onSubmitEditing, secureTextEntry = _param.secureTextEntry, autoComplete = _param.autoComplete, placeholder = _param.placeholder, required = _param.required, props = _object_without_properties(_param, [
        'aria-label',
        "component",
        "hint",
        "inputStyle",
        "error",
        "disabled",
        "label",
        "labelColor",
        "labelWeight",
        "labelHorizontal",
        "variant",
        "value",
        "style",
        "onChangeValue",
        "onFocus",
        "onBlur",
        "onLabelLayout",
        "onSubmitEditing",
        "secureTextEntry",
        "autoComplete",
        "placeholder",
        "required"
    ]);
    var _useState = _sliced_to_array(useState(Platform.OS === 'web' && props.autoFocus), 2), isFocused = _useState[0], setIsFocused = _useState[1];
    var theme = useTheme().theme;
    var _useState1 = _sliced_to_array(useState(!props.multiline || Platform.OS !== 'web'), 2), multilineInitialized = _useState1[0], setMultilineInitialized = _useState1[1];
    var _props_initialContentHeight;
    var _useState2 = _sliced_to_array(useState((_props_initialContentHeight = props.initialContentHeight) !== null && _props_initialContentHeight !== void 0 ? _props_initialContentHeight : 30), 2), contentHeight = _useState2[0], setContentHeight = _useState2[1];
    var _useState3 = _sliced_to_array(useState(0), 2), layoutHeight = _useState3[0], setLayoutHeight = _useState3[1];
    var _useAccessibilityContext = useAccessibilityContext(), isKeyboardShowing = _useAccessibilityContext.isKeyboardShowing, isScreenReaderEnabled = _useAccessibilityContext.isScreenReaderEnabled;
    useEffect(function() {
        if (!multilineInitialized) {
            setMultilineInitialized(true);
        }
    }, [
        multilineInitialized
    ]);
    var Component = component !== null && component !== void 0 ? component : RNTextInput;
    return /*#__PURE__*/ _jsx(AccessibleInput, {
        "aria-label": ariaLabel,
        placeholder: placeholder,
        error: error,
        forwardRef: ref,
        hint: hint,
        label: label,
        labelColor: labelColor,
        labelWeight: labelWeight,
        labelHorizontal: labelHorizontal,
        // casting is needed due to a mismatch b/t ViewStyle and TextStyle props from expo type override
        style: style,
        testID: props.testID,
        required: required,
        onLabelLayout: onLabelLayout,
        children: function(accessibleProps) {
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Component, _object_spread_props(_object_spread(_object_spread_props(_object_spread({}, accessibleProps), {
                        placeholder: error && value ? accessibleProps['aria-label'] : accessibleProps.placeholder,
                        caretHidden: global.e2e,
                        onContentSizeChange: props.multiline ? function(event) {
                            var _props_initialContentHeight;
                            setContentHeight(Math.max(event.nativeEvent.contentSize.height, (_props_initialContentHeight = props.initialContentHeight) !== null && _props_initialContentHeight !== void 0 ? _props_initialContentHeight : 50));
                        } : undefined,
                        placeholderTextColor: "#9191A3",
                        // When a multiline TextInput height is larger than a single line of text, we want the
                        // text/placeholder to be top aligned. If we only have one line of text height, we prefer
                        // to center align so it's more aesthetically pleasing
                        onLayout: function(e) {
                            if (e.nativeEvent.layout.height !== layoutHeight) {
                                setLayoutHeight(e.nativeEvent.layout.height);
                            }
                        },
                        textAlignVertical: props.multiline && Platform.OS === 'android' && layoutHeight > 52 ? 'top' : undefined,
                        style: [
                            props.multiline ? {
                                paddingTop: getStyles(theme).outlined.paddingVertical,
                                minHeight: contentHeight + // if we add to contentHeight on web then onContentSizeChange gets called in an
                                // infinite loop
                                Platform.select({
                                    web: 0,
                                    default: 2
                                })
                            } : null,
                            variant === 'flat' ? getStyles(theme).flat : getStyles(theme).outlined,
                            {
                                borderColor: error ? theme.color.danger : '#C6C6D4'
                            },
                            isFocused ? getStyles(theme).focused : null,
                            disabled ? {
                                opacity: 0.7,
                                backgroundColor: theme.color.gray700
                            } : null,
                            inputStyle
                        ],
                        secureTextEntry: global.e2e ? undefined : secureTextEntry,
                        autoComplete: global.e2e ? undefined : autoComplete
                    }), props), {
                        value: multilineInitialized ? value || '' : '',
                        onChangeText: function(text) {
                            var // use onChangeText if available b/c it's passed by TextInputMask
                            _this;
                            // https://github.com/facebook/react-native/issues/36494
                            // Due to this bug, onChangeText is called an extra time on mount for multiline
                            // TextInput, to avoid the additional callback, we protect against sending the event
                            // if the new value is the same as the current value
                            if (props.multiline && text === value) {
                                return;
                            }
                            (_this = props.onChangeText || onChangeValue) === null || _this === void 0 ? void 0 : _this(text);
                        },
                        onBlur: function(e) {
                            setIsFocused(false);
                            onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
                        },
                        onFocus: function(e) {
                            setIsFocused(true);
                            onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
                        },
                        onSubmitEditing: onSubmitEditing ? function(e) {
                            var _props_testID;
                            addBreadcrumb({
                                category: 'ui.submit',
                                message: (_props_testID = props.testID) !== null && _props_testID !== void 0 ? _props_testID : typeof label === 'string' ? label : undefined,
                                data: {
                                    componentType: 'TextInput',
                                    testID: props.testID,
                                    label: label
                                }
                            });
                            onSubmitEditing(e);
                        } : undefined,
                        readOnly: disabled,
                        // @ts-expect-error
                        dataSet: {
                            nofocusoutline: ''
                        }
                    })),
                    isScreenReaderEnabled && isFocused && isKeyboardShowing ? /*#__PURE__*/ _jsx(Button, {
                        title: "Close keyboard",
                        onPress: Keyboard.dismiss
                    }) : null
                ]
            });
        }
    });
});
/**
 * @nosync
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-43}
 */ export var EmailInput = /*#__PURE__*/ forwardRef(function EmailInput(props, ref) {
    var $t = useI18n().$t;
    return /*#__PURE__*/ _jsx(TextInput, _object_spread({
        autoCapitalize: "none",
        autoComplete: "email",
        inputMode: "email",
        placeholder: $t({
            id: 'EmailInput_label',
            defaultMessage: 'Email'
        }),
        ref: ref
    }, props));
});
/**
 * @nosync
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-43}
 */ export var NumberInput = /*#__PURE__*/ forwardRef(function NumberInput(props, ref) {
    var _useState = _sliced_to_array(useState(props.value ? props.value.toString() : ''), 2), value = _useState[0], setValue = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), error = _useState1[0], setError = _useState1[1];
    useEffect(function() {
        var parsedValue = Number.parseFloat(value);
        if (parsedValue !== props.value) {
            var _props_value;
            var _props_value_toString;
            setValue((_props_value_toString = (_props_value = props.value) === null || _props_value === void 0 ? void 0 : _props_value.toString()) !== null && _props_value_toString !== void 0 ? _props_value_toString : '');
        }
    }, [
        value,
        props.value
    ]);
    return /*#__PURE__*/ _jsx(TextInput, _object_spread_props(_object_spread({}, props), {
        ref: ref,
        value: value.toString(),
        onChangeValue: function(val) {
            var onChangeValue = props.onChangeValue;
            if (!onChangeValue) return;
            if (val === '' && props.value !== null) {
                setError(false);
                onChangeValue(null);
                return;
            }
            var parsedValue = Number.parseFloat(val);
            var nan = Number.isNaN(parsedValue);
            if (!nan && parsedValue !== props.value) {
                onChangeValue(parsedValue);
                setError(false);
            } else if (nan) {
                setError(true);
            }
        },
        error: error ? 'must be a number' : props.error,
        inputMode: "numeric"
    }));
});
/**
 * @nosync
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-43}
 */ export var RequiredNumberInput = /*#__PURE__*/ forwardRef(function RequiredNumberInput(_param, ref) {
    var defaultValue = _param.defaultValue, onChangeValue = _param.onChangeValue, props = _object_without_properties(_param, [
        "defaultValue",
        "onChangeValue"
    ]);
    var _useState = _sliced_to_array(useState(false), 2), isEmpty = _useState[0], setIsEmpty = _useState[1];
    return /*#__PURE__*/ _jsx(NumberInput, _object_spread_props(_object_spread({}, props), {
        ref: ref,
        value: isEmpty ? null : props.value,
        onChangeValue: function(val) {
            if (val === null) {
                setIsEmpty(true);
                onChangeValue(defaultValue);
            } else {
                if (isEmpty) {
                    setIsEmpty(false);
                }
                onChangeValue(val);
            }
        }
    }));
});
